import { selectFeedbackUrl } from 'core/config/firebase/remote-config-slice';
import { useAppSelector } from 'core/hooks/use-app-selector';
import { useTranslationWrapper } from 'core/hooks/use-translation-wrapper';
import { InternationalizationNameSpace } from 'core/models/internationalization-namespace';
import { Icon } from 'hfs-common-ui';
import { Tooltip } from 'react-tooltip';
import * as S from './styled';

const FeedbackLink = () => {
  const { t } = useTranslationWrapper(InternationalizationNameSpace.Core);
  const feedbackUrl = useAppSelector(selectFeedbackUrl);
  return (
    <S.TooltipContainer data-tooltip-id="feedbackTooltipId">
      <S.FeedbackAnchor href={feedbackUrl} target="_blank" rel="noreferrer">
        <Icon type="action.bubble" size="medium" />
        <S.TextSpan>{t('CORE:feedback.link')}</S.TextSpan>
      </S.FeedbackAnchor>
      <Tooltip id="feedbackTooltipId" place="bottom" className="tooltip">
        {t('CORE:feedback.tooltip')}
      </Tooltip>
    </S.TooltipContainer>
  );
};

export default FeedbackLink;
